import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PaginationService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public encodePageInfo(resource: any, sort: string[]) {
    if (!resource) return;
    return btoa(
      encodeURIComponent(
        JSON.stringify({
          id: resource['id'],
          created_at: resource['created_at'],
          ...Object.fromEntries(
            sort.map(sortModel => {
              const name = this.extractResourceFieldFromSortModel(sortModel);
              return [name, resource[name as keyof typeof resource]];
            })
          ),
        })
      )
    );
  }

  private extractResourceFieldFromSortModel(sortModel: string) {
    const sortSymbol = sortModel[0];
    if (['+', '-'].includes(sortSymbol)) {
      return sortModel.slice(1, sortModel.length);
    }
    return sortModel;
  }
}
